































































































	import Vue from 'vue';
	import Component from 'vue-class-component';

	import dateGrossesseService from '@/services/dateGrossesseService.ts';

	const Props = Vue.extend({
		props: {
			//date presume grossesse
			dpg: {
				type: String,
				default: ''
			},
			//mois selectionne
			moisSel: {
				type: String,
				default: ''
			}
		}
	});

/** The Subheader of the application */
@Component
	export default class Subheader extends Props {

		dateGrossesseService = dateGrossesseService;

		periodeEnCours = dateGrossesseService.indexMoisEnCours(this.dpg);
	}
